import { GetContractPersonsQueryDto } from '@ekt-group/general-purpose-api-interfaces';
import { ContractPerson } from '@ekt-group/general-purpose-api-interfaces/src/entities/contract-person.entity';
import { queryOptions, useQuery } from '@tanstack/react-query';

import httpService from '@/lib/http.service';
import { QueryConfig } from '@/lib/react-query';

export const getContractPersons = async (params: Partial<GetContractPersonsQueryDto>, onSuccess: (data: ContractPerson[]) => void) => {
  const response = await httpService.get<ContractPerson[]>(`/contracts/persons`, {
    params,
  });
  
  onSuccess && onSuccess(response.data);

  return response;
};

export const getContractPersonsQueryOptions = (
  params: Partial<GetContractPersonsQueryDto>,
  onSuccess: (data: ContractPerson[]) => void,
) => {
  return queryOptions({
    queryKey: ['contract-persons', params],
    queryFn: () => getContractPersons(params, onSuccess),
  });
};

type UseContractPersonsOptions = {
  params: Partial<GetContractPersonsQueryDto>;
  queryConfig?: QueryConfig<typeof getContractPersonsQueryOptions>;
  onSuccess?: (data: ContractPerson[]) => void;
};

export const useGetContractPersons = ({ queryConfig, params, onSuccess }: UseContractPersonsOptions) => {
  return useQuery({
    ...getContractPersonsQueryOptions(params, onSuccess),
    ...queryConfig,
  });
};
